export const servizioRichiestoShape = {
  codice: "",
  nome: "",
  note: "",
};

export const createServizioRichiestoModel = (overrides = {}) => ({
  ...servizioRichiestoShape,
  ...overrides,
});

